import {createQueryKeys} from "../../shared/query/query-keys";

const queryKeys = createQueryKeys("customerOffers");
export const customerOfferKeys = {
  ...queryKeys,
  bindingDefinitions: () => [...queryKeys.all, "binding-definitions"] as const,
  detail: (id: string) => queryKeys.detail(id.toLowerCase()),
  prepareSend: (id: string) => [...queryKeys.detail(id.toLowerCase()), "prepare-send"] as const,
};
export const customerOfferMutationKeys = {
  setCustomerOfferChapterCommercialOptions: [
    "customerOffers",
    "mutation",
    "set-customer-offer-chapter-commercial-options",
  ] as const,
  setCustomerOfferCoefficient: [
    "customerOffers",
    "mutation",
    "set-customer-offer-coefficient",
  ] as const,
  completeCustomerOfferCoefficientReview: [
    "customerOffers",
    "mutation",
    "complete-customer-offer-coefficient-review",
  ] as const,
  returnCustomerOfferToCoefficientReview: [
    "customerOffers",
    "mutation",
    "return-customer-offer-to-coefficient-review",
  ] as const,
  correctCustomerOfferOutcome: [
    "customerOffers",
    "mutation",
    "correct-customer-offer-outcome",
  ] as const,
  updateDraftCustomerOffer: ["customerOffers", "mutation", "update-draft-customer-offer"] as const,
  submitCustomerOffer: ["customerOffers", "mutation", "submit-customer-offer"] as const,
  approveCustomerOffer: ["customerOffers", "mutation", "approve-customer-offer"] as const,
  moveCustomerOfferToDraft: ["customerOffers", "mutation", "move-customer-offer-to-draft"] as const,
  obsoleteCustomerOffer: ["customerOffers", "mutation", "obsolete-customer-offer"] as const,
  recoverObsoleteCustomerOffer: [
    "customerOffers",
    "mutation",
    "recover-obsolete-customer-offer",
  ] as const,
  sendCustomerOffer: ["customerOffers", "mutation", "send-customer-offer"] as const,
  acceptCustomerOffer: ["customerOffers", "mutation", "accept-customer-offer"] as const,
  rejectCustomerOffer: ["customerOffers", "mutation", "reject-customer-offer"] as const,
  cancelCustomerOffer: ["customerOffers", "mutation", "cancel-customer-offer"] as const,
  createCustomerOfferRevision: [
    "customerOffers",
    "mutation",
    "create-customer-offer-revision",
  ] as const,
  addCustomerOfferNote: ["customerOffers", "mutation", "add-customer-offer-note"] as const,
  editCustomerOfferNote: ["customerOffers", "mutation", "edit-customer-offer-note"] as const,
  removeCustomerOfferNote: ["customerOffers", "mutation", "remove-customer-offer-note"] as const,
} as const;
